// getIsShortAdId.js
'use strict';

// Exported so the code that builds an ad id, or strips the prefix back off,
// shares the one literal with the check below.
const SHORT_AD_ID_PREFIX = 'cta-';

/**
 * Check whether a Shorts item id refers to an ad slide rather than a message.
 * `getShortsIds` prefixes ad ids so both kinds can share one id list.
 * @param {object} param
 * @param {string} [param.id] - a Shorts item id.
 * @returns {boolean} true when the id belongs to an ad slide.
 * @example
 * getIsShortAdId({ id: 'cta-aGVsbG8' });
 * // => true
 * getIsShortAdId({ id: '5f4a1b2c3d4e5f6a7b8c9d0e' });
 * // => false
 */
const getIsShortAdId = ({ id } = {}) =>
  'string' === typeof id && id.startsWith(SHORT_AD_ID_PREFIX);

export { SHORT_AD_ID_PREFIX };
export default getIsShortAdId;
